import React, { FC }                   from 'react';
import { Icon, Message, MessageProps } from 'semantic-ui-react';

export const WarningMessage: FC<MessageProps> = ( props ) => (
	<Message className='fade-in' color={ 'orange' } { ...props }>
		<Message.Content>{ props.children }</Message.Content>
	</Message>
);
